module.exports = __webpack_public_path__ + "img/s2.9c29b279.jpg";